module.exports = __webpack_public_path__ + "media/images/cms/img_slide_21-395bc29a38ba3d6df905623f92bef23e.jpg";